
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[article]/contentful",
      function () {
        return require("private-next-pages/[region]/[article]/contentful.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[article]/contentful"])
      });
    }
  